import React, { createContext, useState } from 'react';

export const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
    const [fileDownloadJobIds, setFileDownloadJobIds] = useState([]);
    const [configuredCopyJobs, setConfiguredCopyJobs] = useState([]);

    const addFileDownloadJobId = (jobId) => {
        setFileDownloadJobIds((prevJobIds) => [...prevJobIds, jobId]);
    };

    const removeFileDownloadJobId = (jobId) => {
        setFileDownloadJobIds((prevJobIds) => prevJobIds.filter((id) => id !== jobId));
    };

    const addConfiguredCopyJob = (job) => {
        setConfiguredCopyJobs((prev) => [...prev, job]);
    };

    const removeConfiguredCopyJob = (jobId) => {
        setConfiguredCopyJobs((prev) => prev.filter((j) => j.jobId !== jobId));
    };

    return (
        <GlobalStateContext.Provider value={{
            fileDownloadJobIds, addFileDownloadJobId, removeFileDownloadJobId,
            configuredCopyJobs, addConfiguredCopyJob, removeConfiguredCopyJob
        }}>
            {children}
        </GlobalStateContext.Provider>
    );
};